import {
  ConfigurationFormType,
  ConfigurationPageTable,
  ConfigurationPageType,
  ConfigurationTableFilterType,
  tableTabAt,
} from "../interfaces";
import { SURQUAL_GRID_TYPE_PAGE } from "./SURQUAL_GRID_TYPE";
import { FormatType } from "../../Alert/Filter/FilterType";

export const MAPPING_ADVANCED_GRID_TYPE_PAGE: ConfigurationPageTable = {
  type: ConfigurationPageType.TABLE,
  isStaff: false,
  flagDisabled: "enable_grid_type_uh_cat_mapping",
  label: "GRID_TYPE_UH_CAT_MAPPING",
  menuLabel: "GRID_TYPE_UH_CAT_MAPPING",
  pageLabel: "GRID_TYPE_UH_CAT_MAPPING_TITLE_MAPPING",
  name: "mapping_grid_type_uh_cat_mapping",
  path: "grid_types_mapping",
  description: "CONF_DESC_MAPPING_GRID_TYPE_ADVANCED",
  model: {
    entityName: "datafeed",
    label: "GRID_TYPE_UH_CAT_MAPPING",
    path: "/api/mapping/grid-types-mapping",
    bulkPath: "/api/mapping/grid-types-mapping/bulk-updates",
    name: "Grille Tarifaire Mapping",
    attributes: [
      {
        key: "client_property_code",
        order: 1,
        label: "CLIENT_PROPERTY_CODE",
        visible: true,
      },
      {
        key: "client_uh_cat_code",
        order: 2,
        label: "CLIENT_UH_CAT_CODE",
        visible: true,
      },
      {
        key: "client_rate_code",
        order: 3,
        label: "CLIENT_RATE_CODE",
        visible: true,
      },
      {
        key: "connector",
        order: 4,
        label: "CONNECTOR_CODE",
        visible: true,
      },
      {
        key: "description",
        order: 5,
        label: "DESCRIPTION",
        visible: true,
      },
      {
        key: "uh_cat.short_name",
        order: 6,
        label: "UH_CAT",
        visible: true,
      },
      {
        key: "grid_type.code",
        order: 7,
        label: "GRID_TYPE",
        visible: true,
      },
      {
        key: "to_import",
        order: 8,
        label: "TO_IMPORT",
        visible: true,
        type: FormatType.BOOLEAN,
      },
      {
        key: "is_active",
        order: 9,
        label: "ACTIVE_F",
        visible: true,
        type: FormatType.BOOLEAN,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
        ],
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/mapping/grid-types-mapping/?is_unmapped=true",
      },
      {
        type: ConfigurationTableFilterType.Duplicate,
        api: "/api/mapping/grid-types-mapping/?is_duplicate=true",
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "property",
        labelKey: "hebergement_nom_court",
        label: "PROPERTY",
        lookup: "uh_cat__property",
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/uh-cats/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "uh_cat",
        labelKey: "short_name",
        label: "UH_CAT",
        lookup: "uh_cat",
        watchLookup: "uh_cat__property",
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "api/mapping/grid-types-mapping/connectors/",
        apiParams: {
          page_size: 100,
          ordering: "connector",
        },
        key: "id",
        labelKey: "id",
        label: "CONNECTOR_CODE",
        lookup: "connector",
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/grid-types/",
        apiParams: {
          page_size: 100,
          ordering: "label",
        },
        key: "grid_type",
        labelKey: "label",
        label: "GRID_TYPE",
        lookup: "grid_type",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/mapping/grid-types-mapping/export" },
    import: { path: "/api/mapping/grid-types-mapping/presign-url" },
    actions: [
      {
        type: "trigger",
        api: "/api/mapping/grid-types-mapping/refresh/",
        label: "REFRESH_GRID_MAPPING",
      },
    ],
  },
  options: {
    formFields: [
      {
        type: ConfigurationFormType.Input,
        key: "client_property_code",
        label: "CLIENT_PROPERTY_CODE",
      },
      {
        type: ConfigurationFormType.Input,
        key: "client_uh_cat_code",
        label: "CLIENT_UH_CAT_CODE",
      },
      {
        type: ConfigurationFormType.Input,
        key: "client_rate_code",
        label: "CLIENT_RATE_CODE",
      },
      {
        type: ConfigurationFormType.Input,
        key: "connector",
        label: "CONNECTOR_CODE",
      },
      {
        type: ConfigurationFormType.Input,
        key: "description",
        label: "DESCRIPTION",
      },
      {
        key: "uh_cat",
        label: "UH_CAT",
        labelKey: "short_name",
        type: ConfigurationFormType.Select,
        api: "/api/uh-cats/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
          property: {
            path: "uh_cat.property.id",
          },
        },
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/grid-types/",
        apiParams: {
          page_size: 100,
          ordering: "code",
        },
        key: "grid_type",
        label: "GRID_TYPE",
        labelKey: "code",
        // Prefill from the table's `grid_type` filter (see uh_cat above).
        watchLookup: "grid_type",
        subCreationForm: tableTabAt(SURQUAL_GRID_TYPE_PAGE.tabs, 0),
      },
      {
        type: ConfigurationFormType.Check,
        key: "to_import",
        label: "TO_IMPORT",
        defaultValue: true,
      },
      {
        type: ConfigurationFormType.Check,
        key: "is_active",
        label: "ACTIVE_F",
        defaultValue: true,
      },
    ],
    copyable: false,
    creatable: true,
    deletable: false,
    editable: true,
    createOptions: [
      {
        key: "client_property_code",
        flex: "50%",
        required: true,
      },
      {
        key: "client_uh_cat_code",
        flex: "50%",
        required: true,
      },
      {
        key: "client_rate_code",
        flex: "50%",
        required: true,
      },
      {
        key: "connector",
        flex: "50%",
      },
      {
        key: "description",
        flex: "100%",
      },
      {
        key: "uh_cat",
        flex: "100%",
        required: true,
      },
      {
        key: "grid_type",
        flex: "100%",
      },
      {
        key: "to_import",
        flex: "50%",
      },
      {
        key: "is_active",
        flex: "50%",
      },
    ],
    editOptions: [
      {
        key: "client_property_code",
        flex: "50%",
        readonly: true,
      },
      {
        key: "client_uh_cat_code",
        flex: "50%",
        readonly: true,
      },
      {
        key: "client_rate_code",
        flex: "50%",
        readonly: true,
      },
      {
        key: "connector",
        flex: "50%",
        readonly: true,
      },
      {
        key: "description",
        flex: "100%",
        readonly: true,
      },
      {
        key: "uh_cat",
        flex: "100%",
        readonly: true,
      },
      {
        key: "grid_type",
        flex: "100%",
      },
      {
        key: "to_import",
        flex: "50%",
      },
      {
        key: "is_active",
        flex: "50%",
      },
    ],
    editSelectedOptions: [
      {
        key: "grid_type",
        flex: "100%",
      },
      {
        key: "to_import",
        flex: "50%",
      },
      {
        key: "is_active",
        flex: "50%",
      },
    ],
  },
};
